<template>
  <div class="trade-buy-sell-amount-picker">
    <button
      v-for="btn in buttons"
      :key="btn.name"
      type="button"
      class="trade-buy-sell-amount-picker__button"
      :class="{
        'trade-buy-sell-amount-picker__button--active' : currentButton === btn,
        'trade-buy-sell-amount-picker__button--big': bigSize
      }"
      @click="clickHandler(btn)"
    >
      <span>
        {{ btn.name }}
      </span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'TradeBuySellAmountPicker',

  props: {
    buttons: {
      type: Array,
      required: true,
    },
    bigSize: {
      type: Boolean,
      default: false,
    },
  },

  data () {
    return {
      currentButton: null,
    }
  },

  methods: {
    clickHandler (btn) {
      this.currentButton = btn
      this.$emit('click', btn)
    },
  },
}
</script>

<style lang="scss" scoped>
.trade-buy-sell-amount-picker {
  $root: &;
  display: flex;
  justify-content: space-between;
  padding-left: toRem(12px);
  padding-right: toRem(12px);

  &__button {
    max-width: toRem(80px);
    border-radius: toRem(36px);
    border: 1px solid color('color-01');
    color: color('color-03');
    padding: toRem(2px) toRem(8px);
    background: color('color-01');
    transition: background .3s ease, color .3s ease;
    font-size: toRem(10px);
    font-weight: 400;
    line-height: toRem(14px);

    @include bp(0, 420px) {
      padding: toRem(6px) toRem(20px);
    }

    &--active,
    &:hover {
      color: color('main');
      border-color: color('main');
    }

    &--big {
      padding: toRem(6px) toRem(26px);
      font-size: toRem(14px);
      font-weight: 500;
      line-height: toRem(18px);
    }
  }
}
</style>
